import { isFinite } from 'lodash';

/**
 * Responses still needed to meet a min-mode floor. Unset stays unset; overshoot is 0.
 */
export function remainingNeeded(remaining) {
  if (!isFinite(remaining)) {
    return undefined;
  }

  return Math.max(0, remaining);
}

export const displayedRemaining = remainingNeeded;

export function isFloorComplete({ remaining, target }) {
  if (!isFinite(remaining) || target === 0) {
    return false;
  }

  return remaining <= 0;
}

export function remainingBarFillPercentage({ remaining, target }) {
  if (!(target > 0)) {
    return 0;
  }

  if (isFinite(remaining) && remaining <= 0) {
    return 100;
  }

  const needed = isFinite(remaining) ? remaining : 0;
  return ((target - needed) / target) * 100;
}

export function shouldWriteRemaining(heldRemaining, nextRemaining) {
  if (isFinite(nextRemaining) && nextRemaining < 0) {
    return false;
  }

  if (nextRemaining === 0 && isFinite(heldRemaining) && heldRemaining < 0) {
    return false;
  }

  return true;
}
